import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

import TimezoneUtil from '../../../util/TimezoneUtil';

import { ToggleButtonGroup } from 'react-bootstrap';

import SchedulerRadioButton from '../SchedulerRadioButton/SchedulerRadioButton';

export default class TimePickerButtonGroup extends Component {
  state = {
    selectedTimeIndex: 0,
    prevSelected: 0,
  };

  componentDidMount() {
    const { onChange } = this.props;
    if (onChange) {
      onChange(0);
    }
  }

  render() {
    var { data, zoneId } = this.props,
      radioBtns = [];

    for (let j = 0; j < data.length; j++) {
      let t = data[j],
        dt = moment(t).tz(zoneId);

      radioBtns.push(
        <SchedulerRadioButton key={t} value={j}>
          <span>{dt.format('hh:mm A') + ' ' + TimezoneUtil.getShortTimezoneStr(dt.format('z'))}</span>
        </SchedulerRadioButton>
      );
    }

    return (
      <ToggleButtonGroup
        type="radio"
        name="timeslots"
        value={this.state.selectedTimeIndex}
        onChange={this.handleTimeSelect.bind(this)}
      >
        {radioBtns}
      </ToggleButtonGroup>
    );
  }

  handleTimeSelect(selectedTimeIndex) {
    this.setState({
      selectedTimeIndex: selectedTimeIndex,
      prevSelected: this.state.selectedTimeIndex,
    });
    const { onChange } = this.props;
    if (onChange) {
      onChange(selectedTimeIndex);
    }
  }
}

TimePickerButtonGroup.propTypes = {
  onChange: PropTypes.func,
  data: PropTypes.array,
  zoneId: PropTypes.string,
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/common/TimePicker/TimePickerButtonGroup.js